import { colorMap } from '@greenlabs/formula-design-token';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { textColorVar, bgColorVar, notificationBaseStyle, buttonNotificationSizeStyle, textStyles } from './styles.css.js';
import { jsx } from 'react/jsx-runtime';

const NotificationCountBadge = ({
  container = "div",
  text,
  size = "md",
  textColor,
  bgColor,
  props = {},
  className = ""
}) => {
  const Container = container; // todo - fix split, validate color props

  const textColorProp = textColor && colorMap[textColor] && bgColor && colorMap[bgColor] ? assignInlineVars({
    [textColorVar]: colorMap[textColor],
    [bgColorVar]: colorMap[bgColor]
  }) : undefined;
  return /*#__PURE__*/jsx(Container, {
    className: `${notificationBaseStyle} ${buttonNotificationSizeStyle[size]} ${className} ${textColorProp ? textStyles : ""}`,
    style: textColorProp,
    ...props,
    children: /*#__PURE__*/jsx("span", {
      children: text
    })
  });
};

NotificationCountBadge.displayName = "NotificationCountBadge";
export { NotificationCountBadge as default };
